import React from 'react'
import { Link } from 'react-router-dom'
import { AiOutlineHome } from 'react-icons/ai'
import './homebutton.css'

const HomeButton = () => {
  return (
    <Link to="/" className="home-button" aria-label="Back to home">
      <AiOutlineHome />
    </Link>
  )
}

export default HomeButton